import { render } from "./FlowPage.vue?vue&type=template&id=349a9388&scoped=true"
import script from "./FlowPage.vue?vue&type=script&lang=js"
export * from "./FlowPage.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-349a9388"

export default script